// extracted by mini-css-extract-plugin
export default {"autoSuggest":"autoSuggest---JOy1F","textFieldDiv":"textFieldDiv---KxQby","downshift":"downshift---eDxWz"};